<template>
  <button class="btn" :type="buttonType || 'button'" @click="propagate($event)" :disabled="spinning">
    <span v-if="spinning" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true">
    </span>
    <slot></slot>
  </button>
</template>

<script>


export default {
  name: "SpinnerButton",
  props: ['spinning', 'buttonType'],

  methods: {
    propagate(event) {
      this.$emit(event.type, event);
    }
  }
};
</script>
<style>

</style>
